import { type ReactNode } from 'react'

/**
 * AUTH_ROUTES (login / register / forgot/* / lock / terms / privacy) 用のシェル。
 * Sidenav / Topbar を持たない単段レイアウト。`data-shell="auth"` で
 * theme.css の `.app[data-shell="auth"]` に切り替え (grid 1 列)。
 */
export interface AuthLayoutProps {
  children: ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps): JSX.Element => (
  <div className="app" data-shell="auth">
    <main className="main">
      <div className="page">{children}</div>
    </main>
  </div>
)
